import { Button, Col, Modal, Row, Typography } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
import ScoreTabs from "./component/score_tabs";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogViewScore = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParams] = useSearchParams();
  const viewOpenScore = searchParams.get("viewOpenScore") || "false";
  const openScore = viewOpenScore === "true" || false;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = openScore;
  // -------------------------- FUNCTION ------------------------
  const handleCancel = () => {
    setSearchParams({});
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={handleCancel}
      open={open}
      footer={null}
      title={null}
      width={1000}
    >
      <div className="sm:p-[2px] lg:p-[16px]">
        <Row gutter={[16, 8]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Typography.Title level={3}>
              Bảng điểm kết quả cá nhân
            </Typography.Title>
            <Typography.Text type="secondary">
              Chào mừng bạn đến với nền tảng của chúng tôi. Mọi câu trả lời đúng
              sẽ được hệ thống tự động ghi nhận và cập nhật vào bảng điểm cá
              nhân của bạn. Bảng điểm này không chỉ là minh chứng cho sự cống
              hiến và độ chính xác của bạn, mà còn là cơ sở để quy đổi thành thu
              nhập. Chúng tôi tin rằng sự chăm chỉ cần được đền đáp xứng đáng.
              Vì vậy, hãy bắt đầu tham gia, hoàn thành nhiệm vụ mỗi ngày và xem
              thu nhập của bạn tăng lên tương ứng với nỗ lực bạn bỏ ra.
            </Typography.Text>
          </Col>
          <Col className="min-h-[400px]" xl={24} lg={24} md={24} xs={24}>
            <ScoreTabs />
          </Col>
          <Col align="right" xl={24} lg={24} md={24} xs={24}>
            <Button
              onClick={handleCancel}
              className="mt-4 min-h-[40px]"
              type="primary"
            >
              Đã xem
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};
export default DialogViewScore;
